import { render } from "./AdminOrderEdit.vue?vue&type=template&id=c5d26374&scoped=true&ts=true&lang=true"
import script from "./AdminOrderEdit.vue?vue&type=script&lang=ts"
export * from "./AdminOrderEdit.vue?vue&type=script&lang=ts"

import "./AdminOrderEdit.vue?vue&type=style&index=0&id=c5d26374&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5d26374"]])

export default __exports__